
import { TranslationProvider, WafBooleanInputTranslations, WafSelectInputTranslations } from "../modules/tcm-form/common/translation-provider";
import { TranslationService } from "../services/translation.service";

export class WafControlsTranslationProvider extends TranslationProvider {
  
  constructor(private translationService: TranslationService) {
    super();
  }
  
  getWeekdayShortName(weekday: number): string {
    throw new Error("Method not implemented.");
  }
  getMonthFullName(month: number): string {
    throw new Error("Method not implemented.");
  }
  getMonthShortName(month: number): string {
    throw new Error("Method not implemented.");
  }

  getSelectInputTranslations(): WafSelectInputTranslations {
    return {
      NoResultsFound: this.translationService.translate(x => x.Controls.Select.NoResultsFound),
      EnterCharacters: this.translationService.translate(x => x.Controls.Select.EnterCharacters),
      Enter2OrMoreCharacters: this.translationService.translate(x => x.Controls.Select.Enter2OrMoreCharacters),
      Enter1OrMoreCharacters: this.translationService.translate(x => x.Controls.Select.Enter1OrMoreCharacters)
    } as WafSelectInputTranslations;
  }

  getBooleanInputTranslations(): WafBooleanInputTranslations {
    return {
      Yes: this.translationService.translate(x => x.Controls.Booleans.Yes),
      No: this.translationService.translate(x => x.Controls.Booleans.No),
      Either: this.translationService.translate(x => x.Controls.Booleans.Either)
    } as WafBooleanInputTranslations;
  }
}
